unit EventViewerEditPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  WEBLib.REST,
  WEBLib.CDS,
  WEBLib.Grids,
  Vcl.Grids;

type
  TEventViewerEditForm = class(TBaseEditForm)
    ErrorConnection: TClientConnection;
    ErrorDataSet: TClientDataSet;
    ErrorDataSetkey: TStringField;
    ErrorDataSetvalue: TStringField;
    ErrorDataSeterror: TStringField;
    ErrorDataSource: TDataSource;
    ErrorFileDataEdit: TMemo;
    ResetButton: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure ResetButtonClick(Sender: TObject);
  private
    { Private declarations }
    FReloadRequired: Boolean;

    [async]
    procedure ResetJob; async;

    [async]
    procedure LoadErrorFile; async;

  protected
    function GetRequiredEditLevel: string; override;

    function CanSaveThis: Boolean; override;

    procedure AfterSetDataset; override;

  public
    { Public declarations }
    property IsReloadRequired: Boolean read FReloadRequired;

  protected procedure LoadDFMValues; override; end;

var
  EventViewerEditForm: TEventViewerEditForm;

implementation

{$R *.dfm}

uses
  App.Shared,
  MainDataModule,
  XData.Web.Client;

function TEventViewerEditForm.GetRequiredEditLevel: string;
begin
  Result :=
    USER_SCOPES[TUserScope.Administrator] + ',' +
    USER_SCOPES[TUserScope.Customer];

end;

procedure TEventViewerEditForm.ResetButtonClick(Sender: TObject);
begin
  inherited;

  ResetJob;

end;

procedure TEventViewerEditForm.ResetJob;
const
  SC_ResetJob = 'IJobsService.ResetJob';

var
  oClientResponse: TXDataClientResponse;
  jsoResponse: TJSObject;
  sMessage: string;

begin
  inherited;

  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_ResetJob,
      [ Dataset.FieldByName('Id').AsInteger ]
    )
  );
  jsoResponse := oClientResponse.ResultAsObject;
  FReloadRequired := Boolean(jsoResponse['value']);

  if FReloadRequired then
    sMessage := 'Job reset successfully'
  else
    sMessage := 'Failed to reset job';

  ShowMessage(sMessage);

end;

procedure TEventViewerEditForm.WebFormShow(Sender: TObject);
begin
  inherited;

  SaveButton.ElementHandle.hidden := True;

end;

function TEventViewerEditForm.CanSaveThis: Boolean;
begin
  Result := False;

end;


procedure TEventViewerEditForm.AfterSetDataset;
begin
  inherited;

  // Load error file asynchronously with proper error handling
  LoadErrorFile;

end;

procedure TEventViewerEditForm.LoadErrorFile;
const
  SC_GetErrorFile = 'IJobsService.GetErrorFile';

var
  oClientResponse: TXDataClientResponse;
  jsoResponse: TJSObject;
  sErrorData: string;
  jsaDataArray: TJSArray;
  jsoElement: TJSObject;

begin
  inherited;

  try
    // Call the service method directly with proper error handling
    oClientResponse := Await(
      TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync(
        SC_GetErrorFile,
        [ DataSource.Dataset.FieldByName('Id').AsInteger ]
      )
    );

    jsoResponse := oClientResponse.ResultAsObject;
    sErrorData := string(jsoResponse['value']);

    // Parse the error data array
    try
      jsaDataArray := TJSArray(TJSJSON.parse(sErrorData));
      if jsaDataArray.Length > 0 then
      begin
        jsoElement := TJSObject(jsaDataArray[0]);
        sErrorData := string(jsoElement['error']);

      end;

    except
      // If parsing fails, use the raw value

    end;

    ErrorFileDataEdit.Text := sErrorData;

  except
    on E: Exception do
    begin
      // Display user-friendly error message
      if Pos('not found', LowerCase(E.Message)) > 0 then
        ErrorFileDataEdit.Text := 'Error file not found. The error file may have been deleted or the job may not have generated an error file.'
      else if Pos('404', E.Message) > 0 then
        ErrorFileDataEdit.Text := 'Error file not found. The error file may have been deleted or the job may not have generated an error file.'
      else if Pos('500', E.Message) > 0 then
        ErrorFileDataEdit.Text := 'Server error occurred while retrieving the error file. Please try again later.'
      else
        ErrorFileDataEdit.Text := 'Unable to retrieve error file. The file may not exist or the connection failed.';

    end;

  end;

end;

procedure TEventViewerEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ErrorFileDataEdit := TMemo.Create('error-file');
  ResetButton := TButton.Create('resolve-item');
  ErrorConnection := TClientConnection.Create(Self);
  ErrorDataSet := TClientDataSet.Create(Self);
  ErrorDataSetkey := TStringField.Create(Self);
  ErrorDataSetvalue := TStringField.Create(Self);
  ErrorDataSeterror := TStringField.Create(Self);
  ErrorDataSource := TDataSource.Create(Self);

  ErrorFileDataEdit.BeforeLoadDFMValues;
  ResetButton.BeforeLoadDFMValues;
  ErrorConnection.BeforeLoadDFMValues;
  ErrorDataSet.BeforeLoadDFMValues;
  ErrorDataSetkey.BeforeLoadDFMValues;
  ErrorDataSetvalue.BeforeLoadDFMValues;
  ErrorDataSeterror.BeforeLoadDFMValues;
  ErrorDataSource.BeforeLoadDFMValues;
  try
    Caption := 'error';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ErrorFileDataEdit.SetParentComponent(Self);
    ErrorFileDataEdit.Name := 'ErrorFileDataEdit';
    ErrorFileDataEdit.Left := 56;
    ErrorFileDataEdit.Top := 144;
    ErrorFileDataEdit.Width := 185;
    ErrorFileDataEdit.Height := 89;
    ErrorFileDataEdit.ElementClassName := 'form-control';
    ErrorFileDataEdit.ElementFont := efCSS;
    ErrorFileDataEdit.HeightPercent := 100.000000000000000000;
    ErrorFileDataEdit.Lines.BeginUpdate;
    try
      ErrorFileDataEdit.Lines.Clear;
      ErrorFileDataEdit.Lines.Add('ErrorFileDataEdit');
    finally
      ErrorFileDataEdit.Lines.EndUpdate;
    end;
    ErrorFileDataEdit.ReadOnly := True;
    ErrorFileDataEdit.SelLength := 0;
    ErrorFileDataEdit.SelStart := 0;
    ErrorFileDataEdit.WidthPercent := 100.000000000000000000;
    ResetButton.SetParentComponent(Self);
    ResetButton.Name := 'ResetButton';
    ResetButton.Left := 56;
    ResetButton.Top := 239;
    ResetButton.Width := 96;
    ResetButton.Height := 25;
    ResetButton.Caption := 'Reset';
    ResetButton.ChildOrder := 10;
    ResetButton.ElementClassName := 'btn btn-light';
    ResetButton.ElementFont := efCSS;
    ResetButton.ElementPosition := epIgnore;
    ResetButton.HeightStyle := ssAuto;
    ResetButton.HeightPercent := 100.000000000000000000;
    ResetButton.WidthStyle := ssAuto;
    ResetButton.WidthPercent := 100.000000000000000000;
    SetEvent(ResetButton, Self, 'OnClick', 'ResetButtonClick');
    ErrorConnection.SetParentComponent(Self);
    ErrorConnection.Name := 'ErrorConnection';
    ErrorConnection.Active := False;
    ErrorConnection.DataNode := 'value';
    ErrorConnection.Delimiter := ';';
    ErrorConnection.Left := 640;
    ErrorConnection.Top := 40;
    ErrorDataSet.SetParentComponent(Self);
    ErrorDataSet.Name := 'ErrorDataSet';
    ErrorDataSet.Active := True;
    ErrorDataSet.Connection := ErrorConnection;
    ErrorDataSet.Left := 641;
    ErrorDataSet.Top := 112;
    ErrorDataSetkey.SetParentComponent(ErrorDataSet);
    ErrorDataSetkey.Name := 'ErrorDataSetkey';
    ErrorDataSetkey.FieldName := 'key';
    ErrorDataSetkey.Size := 64;
    ErrorDataSetvalue.SetParentComponent(ErrorDataSet);
    ErrorDataSetvalue.Name := 'ErrorDataSetvalue';
    ErrorDataSetvalue.FieldName := 'value';
    ErrorDataSetvalue.Size := 64;
    ErrorDataSeterror.SetParentComponent(ErrorDataSet);
    ErrorDataSeterror.Name := 'ErrorDataSeterror';
    ErrorDataSeterror.FieldName := 'error';
    ErrorDataSeterror.Size := 512;
    ErrorDataSource.SetParentComponent(Self);
    ErrorDataSource.Name := 'ErrorDataSource';
    ErrorDataSource.DataSet := ErrorDataSet;
    ErrorDataSource.Left := 640;
    ErrorDataSource.Top := 176;
  finally
    ErrorFileDataEdit.AfterLoadDFMValues;
    ResetButton.AfterLoadDFMValues;
    ErrorConnection.AfterLoadDFMValues;
    ErrorDataSet.AfterLoadDFMValues;
    ErrorDataSetkey.AfterLoadDFMValues;
    ErrorDataSetvalue.AfterLoadDFMValues;
    ErrorDataSeterror.AfterLoadDFMValues;
    ErrorDataSource.AfterLoadDFMValues;
  end;
end;

end.